
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A51931","d":"M0 0h9v6H0z"}}),_c('path',{attrs:{"fill":"#F4F5F8","d":"M0 1h9v4H0z"}}),_c('path',{attrs:{"fill":"#2D2A4A","d":"M0 2h9v2H0z"}})])
          )
        }
      }
    